import { SprintAccessRight } from "./SprintAccessRight";

export interface User {
    name: string;
    email: string;
    roles: UserRole[];
    accessRights: SprintAccessRight[];
    accessToken: string;
    idToken: string;
    originatorIds: string[];
}

export interface UserTokens {
    idToken: string;
    accessToken: string;
}

export enum UserRole {
    Admin = "Admin",
    Hub = "Hub",
    User = "User"
}

const existValueInEnum = (type: Record<string, string>, value: string): boolean => {
    return (
        Object.keys(type)
            .filter((k: string) => isNaN(Number(k)))
            .filter((k: string) => type[k] === value).length > 0
    );
};

export const parseRoles = (userGroupsString: string): UserRole[] => {
    if (!userGroupsString) {
        return [];
    }

    return userGroupsString
        .replace("[", "")
        .replace("]", "")
        .split(",")
        .map((group: string) => group.trim())
        .filter((group: string) => existValueInEnum(UserRole, group)) as UserRole[];
};
